import {Storage} from '@infra/api';
import {FIRST_LOGIN_KEY} from '@infra/domain/model/Auth/ApiAuthRepository';

const IsFirstLogin = () => async (): Promise<boolean> => (await Storage.get(FIRST_LOGIN_KEY)) !== 'false';

export {IsFirstLogin};
